import { useQuery, useQueryClient } from '@tanstack/react-query'
import { GETSystemCatalogItems } from '../queries'

function useGetSystemCatalogItems() {
  const queryClient = useQueryClient()
  const queryKey = ['system_catalog_items']

  const query = useQuery({
    queryFn: async () => await GETSystemCatalogItems(),
    queryKey: queryKey,
    refetchOnMount: 'always',
  })

  const invalidateQuery = () => {
    return queryClient.invalidateQueries({ queryKey: queryKey })
  }

  return {
    query,
    invalidateQuery,
  }
}

export default useGetSystemCatalogItems
